export enum LookupEnum {
	Other = 99,
    LargeListOther = 999
}